<div
  class="flex flex-row w-full items-center py-3 gap-8 justify-between border-t border-b border-[#D9D9D9]"
>
  <div
    class="session-box__link flex flex-row flex-1 items-center gap-8 justify-between"
    role="link"
    tabindex="0"
    (click)="openParking()"
    (keydown.enter)="openParking()"
  >
    <div class="flex flex-col w-64">
      @if (session().zone) {
      <span class="text-base mb-1"
        >{{ 'SHARED_SESSION_BOX_ZONE_PREFIX' | localization }} {{ session().zone?.number }}</span
      >
      } @else {
      <span class="text-base mb-1" data-cy="session-no-parking">{{
        'SHARED_SESSION_BOX_NO_PARKING' | localization
      }}</span>
      }
      <span class="text-sm text-[--description-color]">{{ session().house }}</span>
    </div>

    <div class="flex-shrink-0 w-32">
      <span>{{ session().vehicle.vrp }}</span>
    </div>

    <div class="flex-shrink-0 w-48 text-center">
      @if (progress.isPending()) {
      <span class="text-sm text-[--description-color]" data-cy="session-pending">{{
        'SHARED_SESSION_BOX_PENDING' | localization
      }}</span>
      } @else {
      <span class="text-sm">{{
        'SHARED_SESSION_BOX_UNTIL' | localization : { dateTime: progress.until() }
      }}</span>
      }
    </div>

    <div class="flex-shrink-0 w-30" [class.invisible]="progress.isPending()">
      <span class="text-xs">{{ progress.remainingTime() }}</span>
      <nz-progress
        [nzPercent]="progress.progressBar()"
        [nzShowInfo]="false"
        [nzStrokeColor]="'#4CB050'"
      ></nz-progress>
    </div>
  </div>

  @if (progress.isActive()) {
  <div class="flex-shrink-0 flex-wrap flex space-x-3">
    @if (progress.canInterrupt()) {
    <ui-button
      type="primary"
      color="danger"
      size="small"
      data-cy="session-interrupt"
      (click)="interruptParkingModal.emit(session())"
      >{{ 'SHARED_SESSION_BOX_INTERRUPT_BUTTON' | localization }}
    </ui-button>
    }
    <ui-button type="primary" size="small" (click)="prolongParkingModal.emit(session())"
      >{{ 'SHARED_SESSION_BOX_PROLONG_BUTTON' | localization }}
    </ui-button>
  </div>
  }
</div>
